import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface DeviceTypeState {
  deviceType: string;
}

const initialState: DeviceTypeState = {
  deviceType: 'web',
};

const deviceTypeSlice = createSlice({
  name: 'deviceType',
  initialState,
  reducers: {
    setDeviceType(state, action: PayloadAction<string>) {
      state.deviceType = (action.payload || 'web').toLowerCase();
    },
    clearDeviceType(state) {
      state.deviceType = 'web';
    },
  },
});

export const { setDeviceType, clearDeviceType } = deviceTypeSlice.actions;
export const deviceTypeSelector = (state: RootState) => state?.deviceType?.deviceType || 'web';
export default deviceTypeSlice.reducer;
